<template>
  <footer class="footer">
    <div class="webFooterMain">
      <button @click.prevent="webPlan()" type="submit" class="webFooterFont">Mentions légales</button>
    </div>
    <br>
    <div class="webFooterLine2">
      <a href="https://www.pexels.com/fr-fr/" class="webFooterFont">Banque d'image issue de Pexels</a>
    </div>
    <br>
    <img class="webFooterImg" src="../../assets/Banniere.jpg" alt="Banniere">
  </footer>
</template>

<script>
export default {
  name: 'webFooterMain',
  data () {
    return {
    }
  },
  methods: {
    webPlan () {
      this.$router.push('/MentionsLegales')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteWeb/Footer.vue